module.exports = __webpack_public_path__ + "static/media/tiktok-top-icons-es.22f243bd.svg";